"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Wrapper = _interopRequireDefault(require("./Wrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function IconList(props) {
  var ComponentToRender = props.component;

  var content = _react["default"].createElement("div", null);

  var paneTitle = props.paneTitle;
  var className = props.className; // If we have items, render them

  if (props.items) {
    content = props.items.map(function (item) {
      return _react["default"].createElement(ComponentToRender, {
        key: "item-".concat(item.ref),
        item: item
      });
    });
  } else {
    // Otherwise render a single component
    content = _react["default"].createElement(ComponentToRender, null);
  }

  if (props.paneTitle) {
    return _react["default"].createElement(_Wrapper["default"], {
      className: "container-fluid"
    }, _react["default"].createElement("h2", {
      className: "pane-title"
    }, props.paneTitle), _react["default"].createElement("ul", {
      className: className
    }, content));
  } else {
    return _react["default"].createElement(_Wrapper["default"], {
      className: "container-fluid"
    }, _react["default"].createElement("ul", {
      className: className
    }, content));
  }
}

IconList.defaultProps = {
  items: [],
  className: "icon-list",
  paneTitle: "Icon List"
};
IconList.propTypes = {
  component: _propTypes["default"].func.isRequired,
  items: _propTypes["default"].array,
  className: _propTypes["default"].string,
  paneTitle: _propTypes["default"].string
};
var _default = IconList;
exports["default"] = _default;